import { asString, loadedDefinedMap, asBoolean, asDate } from "common/components/component-helpers";
import { ActionSource } from "common/components/types";
import { GlideFunctionalRenderer } from "common/components/uis";
import EventPickerButton from "webapp/ui/views/event-picker-button/event-picker-button";
import { formatShortDate, formatShortTime } from "common/components/localization";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useForce } from "hooks/use-force";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";
import { useEditComponentEnabledViaNetworkStatus } from "hooks/use-edit-components-enabled-via-network-status";

export const EventPickerButtonMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [
        [isEnabledPV, eventStartPV, eventEndPV, onClickPV, onClearPV, titlePV, placeholderPV, isRequiredPV],
    ] = useForceValueProducers(getValueProducers, force, ctx);
    const { onClick: onClickCB } = useOnClickFromAction(onClickPV, ActionSource.None, ctx, env);
    const { onClick: onClearCB } = useOnClickFromAction(onClearPV, ActionSource.None, ctx, env);
    const [editingAllowed] = useEditComponentEnabledViaNetworkStatus(env);

    const isEnabled = loadedDefinedMap(isEnabledPV, asBoolean) ?? true;
    const enabled = editingAllowed && isEnabled;

    const eventStart = loadedDefinedMap(eventStartPV, asDate);
    const eventEnd = loadedDefinedMap(eventEndPV, asDate);
    const onClick = () => onClickCB?.(undefined);
    const onClear = () => onClearCB?.(undefined);
    const title = loadedDefinedMap(titlePV, asString);
    const placeholder = loadedDefinedMap(placeholderPV, asString);
    const isRequired = loadedDefinedMap(isRequiredPV, asBoolean);

    let eventTitle: string | undefined;
    let eventDesc: string | undefined;

    if (eventStart !== undefined && eventEnd !== undefined) {
        eventTitle = formatShortDate(eventStart, false);
        if (new Date(eventStart).setHours(0, 0, 0, 0) !== new Date(eventEnd).setHours(0, 0, 0, 0)) {
            eventTitle += "— " + formatShortDate(eventEnd, false);
        }

        eventDesc = `${formatShortTime(eventStart)} - ${formatShortTime(eventEnd)}`;
    }

    return (
        <EventPickerButton
            isEnabled={enabled}
            onClick={onClick}
            onClear={onClear}
            eventTitle={eventTitle}
            eventDesc={eventDesc}
            title={title}
            placeholder={placeholder ?? "FIXME"}
            isRequired={isRequired ?? false}
            hasEvent={eventStart !== undefined && eventEnd !== undefined}
        />
    );
};
